<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ded">
<p class="center"><em>To all our family and friends, living and dead,<br/>who shared their stories with us;<br/>to the readers who will pass them on;<br/>and in memory of our friends,<br/>Karen Harrigan and Drewry Meece Jr.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780813173894_epub_ded_r1.vue?54aec385